import { withMetadata } from '../metadata'
import { getExtPrefix as _getExtPrefix } from '../../core/index'

export function getExtPrefix() {
	return withMetadata(_getExtPrefix, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/min/exports/getExtPrefix.js
// module id = 635
// module chunks = 0